import NavbarFr from '../components/NavbarFr';
import FooterFr from 'components/FooterFr';
import { useSelector } from "react-redux";
import MobileNavbarFr from 'components/MobileNavbarFr';
import HomePageFr from 'components/Home/HomePageFr';
import MobileFooterFr from 'components/MobileFooterFr';

function HomeFr() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <HomePageFr />
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <HomePageFr />
      <FooterFr />
      </>
    )}
    </>
  );
}

export default HomeFr;
